<div class="pagination">
  <div class="total">
    {{ totalItems }} {{ "components.pagination.total" | translate }}
  </div>

  <div class="pagination-controls">
    <!-- CI-Pager (design/portal-ci): Pfeile als `.al-icon-button` mit
         CI-Chevrons, Seitenzahlen als `.al-page` — gleiche Breite und Höhe,
         die aktive ein blauer Kreis über `aria-current="page"`. Material,
         Hover, Fokus, Deaktiviert und Kontrastmodus kommen aus
         alphalearn-ci.css. Jeder Knopf `type="button"`: im Bucket-Dialog
         steht der Pager in einem <form>. Die aktive Seite nie `disabled` —
         `.al-page:disabled` färbte die weiße Ziffer grau. Die Pfeile an
         der Grenze sind `aria-disabled`, nicht `disabled`: ein Knopf, der
         sich beim Klick selbst sperrt, wirft den Tastaturfokus auf <body>
         (im Dialog landet der nächste Tab dann hinter dem Modal). -->
    <nav
      class="pagination-buttons"
      [attr.aria-label]="'components.pagination.navLabel' | translate"
    >
      <button
        type="button"
        class="al-icon-button"
        [attr.aria-disabled]="atStart || null"
        [attr.aria-label]="'components.pagination.first' | translate"
        (click)="atStart || onPageChange(0)"
      >
        <span class="al-icon al-icon--chevrons-left" aria-hidden="true"></span>
      </button>
      <button
        type="button"
        class="al-icon-button"
        [attr.aria-disabled]="atStart || null"
        [attr.aria-label]="'components.pagination.previous' | translate"
        (click)="atStart || onPageChange(currentPage - 1)"
      >
        <span class="al-icon al-icon--chevron-left" aria-hidden="true"></span>
      </button>

      @for (page of visiblePages; track page) {
      <button
        type="button"
        class="al-page"
        [attr.aria-current]="currentPage === page ? 'page' : null"
        [attr.aria-label]="'components.pagination.page' | translate: { page: page + 1 }"
        (click)="onPageChange(page)"
      >{{ page + 1 }}</button>
      }

      <button
        type="button"
        class="al-icon-button"
        [attr.aria-disabled]="atEnd || null"
        [attr.aria-label]="'components.pagination.next' | translate"
        (click)="atEnd || onPageChange(currentPage + 1)"
      >
        <span class="al-icon al-icon--chevron-right" aria-hidden="true"></span>
      </button>
      <button
        type="button"
        class="al-icon-button"
        [attr.aria-disabled]="atEnd || null"
        [attr.aria-label]="'components.pagination.last' | translate"
        (click)="atEnd || onPageChange(totalPages.length - 1)"
      >
        <span class="al-icon al-icon--chevrons-right" aria-hidden="true"></span>
      </button>
    </nav>

    @if (pageSizeOptions?.length) {
    <div class="page-size-select">
      <nb-select
        size="small"
        [selected]="itemsPerPage"
        (selectedChange)="onItemsPerPageChange($event)"
      >
        @for (option of pageSizeOptions; track option) {
        <nb-option [value]="option">{{ option }}</nb-option>
        }
      </nb-select>
    </div>
    }
  </div>
</div>
